import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { onUnexpectedExternalError } from '../../../base/common/errors.js';
import { MAX_LINE_NUMBER, FoldingRegions } from './foldingRanges.js';
var MAX_FOLDING_REGIONS = 5000;
var foldingContext = {};
export var ID_SYNTAX_PROVIDER = 'syntax';
export var SyntaxRangeProvider = /*#__PURE__*/function () {
  function SyntaxRangeProvider(editorModel, providers) {
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_FOLDING_REGIONS;

    _classCallCheck(this, SyntaxRangeProvider);

    this.editorModel = editorModel;
    this.providers = providers;
    this.limit = limit;
    this.id = ID_SYNTAX_PROVIDER;
  }

  _createClass(SyntaxRangeProvider, [{
    key: "compute",
    value: function compute(cancellationToken) {
      var _this = this;

      return collectSyntaxRanges(this.providers, this.editorModel, cancellationToken).then(function (ranges) {
        if (ranges) {
          var res = sanitizeRanges(ranges, _this.limit);
          return res;
        }

        return null;
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);

  return SyntaxRangeProvider;
}();

function collectSyntaxRanges(providers, model, cancellationToken) {
  var rangeData = null;
  var promises = providers.map(function (provider, i) {
    return Promise.resolve(provider.provideFoldingRanges(model, foldingContext, cancellationToken)).then(function (ranges) {
      if (cancellationToken.isCancellationRequested) {
        return;
      }

      if (Array.isArray(ranges)) {
        if (!Array.isArray(rangeData)) {
          rangeData = [];
        }

        var nLines = model.getLineCount();

        var _iterator = _createForOfIteratorHelper(ranges),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var r = _step.value;

            if (r.start > 0 && r.end > r.start && r.end <= nLines) {
              rangeData.push({
                start: r.start,
                end: r.end,
                rank: i,
                kind: r.kind
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, onUnexpectedExternalError);
  });
  return Promise.all(promises).then(function (_) {
    return rangeData;
  });
}

export var RangesCollector = /*#__PURE__*/function () {
  function RangesCollector(foldingRangesLimit) {
    _classCallCheck(this, RangesCollector);

    this._startIndexes = [];
    this._endIndexes = [];
    this._nestingLevels = [];
    this._nestingLevelCounts = [];
    this._types = [];
    this._length = 0;
    this._foldingRangesLimit = foldingRangesLimit;
  }

  _createClass(RangesCollector, [{
    key: "add",
    value: function add(startLineNumber, endLineNumber, type, nestingLevel) {
      if (startLineNumber > MAX_LINE_NUMBER || endLineNumber > MAX_LINE_NUMBER) {
        return;
      }

      var index = this._length;
      this._startIndexes[index] = startLineNumber;
      this._endIndexes[index] = endLineNumber;
      this._nestingLevels[index] = nestingLevel;
      this._types[index] = type;
      this._length++;

      if (nestingLevel < 30) {
        this._nestingLevelCounts[nestingLevel] = (this._nestingLevelCounts[nestingLevel] || 0) + 1;
      }
    }
  }, {
    key: "toIndentRanges",
    value: function toIndentRanges() {
      if (this._length <= this._foldingRangesLimit) {
        var startIndexes = new Uint32Array(this._length);
        var endIndexes = new Uint32Array(this._length);

        for (var i = 0; i < this._length; i++) {
          startIndexes[i] = this._startIndexes[i];
          endIndexes[i] = this._endIndexes[i];
        }

        return new FoldingRegions(startIndexes, endIndexes, this._types);
      } else {
        var entries = 0;
        var maxLevel = this._nestingLevelCounts.length;

        for (var _i = 0; _i < this._nestingLevelCounts.length; _i++) {
          var n = this._nestingLevelCounts[_i];

          if (n) {
            if (n + entries > this._foldingRangesLimit) {
              maxLevel = _i;
              break;
            }

            entries += n;
          }
        }

        var _startIndexes = new Uint32Array(this._foldingRangesLimit);

        var _endIndexes = new Uint32Array(this._foldingRangesLimit);

        var types = [];

        for (var _i2 = 0, k = 0; _i2 < this._length; _i2++) {
          var level = this._nestingLevels[_i2];

          if (level < maxLevel || level === maxLevel && entries++ < this._foldingRangesLimit) {
            _startIndexes[k] = this._startIndexes[_i2];
            _endIndexes[k] = this._endIndexes[_i2];
            types[k] = this._types[_i2];
            k++;
          }
        }

        return new FoldingRegions(_startIndexes, _endIndexes, types);
      }
    }
  }]);

  return RangesCollector;
}();
export function sanitizeRanges(rangeData, limit) {
  var sorted = rangeData.sort(function (d1, d2) {
    var diff = d1.start - d2.start;

    if (diff === 0) {
      diff = d1.rank - d2.rank;
    }

    return diff;
  });
  var collector = new RangesCollector(limit);
  var top = undefined;
  var previous = [];

  var _iterator2 = _createForOfIteratorHelper(sorted),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var entry = _step2.value;

      if (!top) {
        top = entry;
        collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
      } else {
        if (entry.start > top.start) {
          if (entry.end <= top.end) {
            previous.push(top);
            top = entry;
            collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
          } else {
            if (entry.start > top.end) {
              do {
                top = previous.pop();
              } while (top && entry.start > top.end);

              if (top) {
                previous.push(top);
              }

              top = entry;
            }

            collector.add(entry.start, entry.end, entry.kind && entry.kind.value, previous.length);
          }
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return collector.toIndentRanges();
}